import {
	booleanAttribute,
	Component,
	Input,
	OnInit,
	SimpleChange,
} from "@angular/core"
import { Configcliniq } from "@app/definitions/types"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { ModalService } from "@app/services/modal.service"
@Component({
	selector: "app-cc-sections",
	templateUrl: "./cc-sections.component.html",
})
export class CcSectionsComponent {
	@Input() name: string = ""
	@Input() section: string = ""
	@Input({ transform: booleanAttribute }) hideTitle: boolean = false

	configcliniq: Configcliniq //the config DB obj

	sections: any[] = []

	areaSections = {
		user_area: [
			{
				tableName: "affiliated_users",
				title: "affiliated_users",
				color: "#eee7b6",
				isOpen: false,
			},
		],
		patients: [
			{
				tableName: "patients",
				title: "patients",
				color: "#d0a747",
				isOpen: false,
			},
			{ tableName: "groups", title: "groups", color: "#f7b2c2" },
			{ tableName: "inquirers", title: "inquirers", color: "#ac85bc" },
			// { tableName: "patienttypes", title: "patienttypes", color: "#E2F0CB"},
			{
				tableName: "cc-insert-patient-templates",
				title: "select_fields",
				color: "#699fca",
				nonTable: true,
			},
			{ tableName: "patientfields", title: "patientfields", color: "#c8e7d9" },
			{
				tableName: "patient-details-fields-manage",
				title: "patient_details_fields",
				color: "#7c9c6b",
				nonTable: true,
			},
			{ tableName: "referers", title: "referers", color: "#E3ED00" },
			// { tableName: "inquiry_statuses", title: "inquiry_statuses", color: "#cafde0"},
			{
				tableName: "patient_unification",
				title: "patient_unification",
				color: "#c4ac78",
				nonTable: true,
			},
			{
				tableName: "import-patients",
				title: "import_patients",
				color: "#c4abb4",
				nonTable: true,
			},
			{
				tableName: "import-followups",
				title: "import_followups",
				color: "#92afcc",
				nonTable: true,
			},
			{ tableName: "contactway_list", title: "emails", color: "#93cdce" },
		],
		multiuser: [
			{
				tableName: "sub_users",
				title: "sub_users_dashboard",
				color: "#a7d6a3",
				isOpen: true,
			},
			{
				tableName: "cc-params-user-details",
				title: "multiuserdetails",
				color: "#c0dc8f",
				nonTable: true,
			},
			{
				tableName: "sub-user",
				title: "userdetails",
				color: "#c8c9a9",
				nonTable: true,
			},

			{
				tableName: "user",
				title: "my_account",
				color: "#c2b39c",
				nonTable: true,
			},

			{ tableName: "clinic_roles", title: "roles", color: "#fee4cd" },
			{ tableName: "locations", title: "locations", color: "#efe6e3" },
			{ tableName: "tags", title: "tags", color: "#f4817e" },
			{
				tableName: "import-tags",
				title: "import_tags",
				color: "#cd92c1",
				nonTable: true,
			},
			{ tableName: "meetingtypes", title: "meetingtypes", color: "#9676b5" },
			{ tableName: "tarifs", title: "tarif", color: "#b4d9f3" },

			{
				tableName: "sub_user_groups",
				title: "sub_user_groups",
				color: "#a4d0d1",
			},
			{ tableName: "partners", title: "partners", color: "#a0c2b4" },
			// { tableName: "cc-reports", title: "reports",color: "#d3d3d3",nonTable:true},
		],
		subuser: [
			{
				tableName: "cc-params-sub-user",
				title: "sub_user_area",
				color: "#7bc580",
				nonTable: true,
			},
		],

		taxes: [
			// { tableName: "financial", title: "financial",color: "#FFB7B2", isOpen: true, isTable:false },
			{ tableName: "taxes", title: "taxes", color: "#bab974" },
			{ tableName: "payors", title: "payors", color: "#f2d440" },
			{
				tableName: "accountant",
				title: "accountant",
				color: "#baa88d",
				nonTable: true,
			},
			{ tableName: "expensetypes", title: "expensetypes", color: "#fbba89" },
			{ tableName: "suppliers", title: "suppliers", color: "#c5a6a2" },
			// { tableName: "hashav", title: "hashav", color: "#FFDA11",nonTable:true },

      {
				tableName: "ownerbankaccounts",
				title: "ownerbankaccounts",
				color: "#a694c7",
			},
			{
				tableName: "credit-clearance",
				title: "credit_clearance",
				color: "#32a4d5",
				nonTable: true,
			},
      {
				tableName: "ita-get-auth",
				title: "ita_get_auth",
				color: "#519d9f",
				nonTable: true,
			},
		],
		"info-tables": [
			{ tableName: "medics", title: "medics", color: "#519d9f", isPagi: true },
			{ tableName: "nondrugs", title: "nondrugs", color: "#c9e6d3" },
			{ tableName: "labtests", title: "labtests", color: "#9bc09a" },
			{
				tableName: "diagps",
				title: "diagnosis",
				color: "#7e975d",
				isPagi: true,
			},
		],
		// "document-and-quest":[
		tests: [
			{
				tableName: "tests",
				title: "tests",
				color: "#cecac5",
				isOpen: true,
				nonTable: true,
			},
			{
				tableName: "public_tests",
				title: "public_tests",
				color: "#d0c491",
				nonTable: true,
			},
			// { tableName: "documenttemplates", title: "documenttemplates",color: "#FFB7B2" },
		],
		journal: [
			// { tableName: "calendar_config", title: "calendar_config",color: "#FFB7B2", isOpen: true, isTable:false },
			{ tableName: "meetingtypes", title: "meetingtypes", color: "#fecb8b" },
			{ tableName: "followuptypes", title: "followuptypes", color: "#c8ada0" },
			{
				tableName: "holiday",
				title: "holiday",
				color: "#f79f99",
				nonTable: true,
			},
		],
		"home-super-admin": [
			{ tableName: "dblogs", title: "dblogs", color: "#b9b8d0" },
			{ tableName: "users", title: "users", color: "#a3c6df" },
			{ tableName: "faqs", title: "faqs", color: "#97c2aa" },
			{
				tableName: "activity",
				title: "activity",
				color: "#6d9f71",
				nonTable: true,
			},
		],
		user_payments: [
			// { tableName: "financial", title: "financial",color: "#FFB7B2", isOpen: true, isTable:false },
			{
				tableName: "payment",
				title: "payment",
				color: "#cbdf7d",
				nonTable: true,
			},
			{
				tableName: "admininvoices",
				title: "admininvoices",
				color: "#bcb0b3",
				nonTable: true,
			},

			{
				tableName: "affiliated_users",
				title: "affiliated_users",
				color: "#ffd100",
			},
		],
		automation: [
			{
				tableName: "accountant",
				title: "accountant",
				color: "#efd795",
				nonTable: true,
			},
			{ tableName: "patients_sms", title: "patients_sms", color: "#d3aa73" },
		],
		security: [
			{
				tableName: "change_password",
				title: "change_password",
				color: "#eaa380",
				nonTable: true,
			},
		],
		self_coordination: [
			{
				tableName: "user-details-website",
				title: "userdetails_website",
				color: "#f4817e",
				nonTable: true,
			},
		],
	}

	constructor(
		public store: StoreService,
		public permsService: PermsService,
		public modalService: ModalService
	) {
		this.configcliniq = this.store.getCliniqDataOrExit()
	}

	ngOnChanges(changes: SimpleChange) {
		//if person changed (ex: contact) - send to load function
		if (changes["section"]) {
			this.sections = this.areaSections[this.section] || []
		}
	}

	openSection(section: any) {
		const curIsClosed = !section.isOpen
		this.sections.forEach((section) => (section.isOpen = false))
		if (curIsClosed) {
			section.isOpen = true
		}
	}
}
